<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Taxas'"
      :titulo="'taxas'"
    />
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <p class="h-6 rf_texto">
            Validade das Taxas - <strong>{{ validade }}</strong>
          </p>
          <div class="col-5">
            <div class="form-floating">
              <div class="input-group-append mt-2">
                <input
                  type="file"
                  class="form-control rf_bg_form rf_texto"
                  name="file"
                  ref="files"
                />
              </div>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                for="inputGroupFile02"
                @click="importar"
              >
                <i class="bi bi-download" title="Importar Taxas"></i>
              </button>
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#ModalCadastrar"
              >
                <i class="bi bi-plus-circle" title="Cadastrar Taxa"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                for="inputGroupFile02"
                @click="importar"
              >
                <span class="rf_texto_btn">Importar</span>
              </button>
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-toggle="modal"
                data-bs-target="#ModalCadastrar"
              >
                <span class="rf_texto_btn">Cadastrar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                for="inputGroupFile02"
                @click="importar"
              >
                <span class="rf_texto_btn">Importar</span>
              </button>
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-toggle="modal"
                data-bs-target="#ModalCadastrar"
              >
                <span class="rf_texto_btn">Cadastrar</span>
              </button>
            </div>
          </div>
          <div v-if="abrir_modal">
            <Message :msg="msg" v-show="msg" />
          </div>
        </div>
      </div>
    </div>
    <!--Bloco do Filtro-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-funnel fs-5 icon-text-form"></i>
            <span class="txt-title-form">Filtro</span>
          </div>
        </div>
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control rf_bg_form rf_texto"
                v-model="filtros.desc_taxa"
              />
              <label>Plano</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="filtros.pageSize"
                @change="handlePageSizeChange(filtros.pageSize)"
              >
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
              <label>Itens pág.</label>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  retrieveTaxas();
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveTaxas();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveTaxas();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tabelas-->
    <div class="card-container">
      <div class="card card-table-txt">
        <div class="d-md-none">
          <div v-for="item in itens" :key="item.id" class="accordion mb-2">
            <div class="accordion-item">
              <button
                class="accordion-button collapsed card-table-txt"
                data-bs-toggle="collapse"
                :data-bs-target="'#row-' + item.id"
              >
                {{ item.Name }}
              </button>
              <div :id="'row-' + item.id" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p>
                    <strong>Financeira:</strong>
                    {{ item.bancos_full ? item.bancos_full.nome : "N/A" }}
                  </p>
                  <p>
                    <strong>Retorno:</strong>
                    {{ item.ReturnType }}
                  </p>
                  <p>
                    <strong>Ano Inicial:</strong>
                    {{ item.StartYear }}
                  </p>
                  <p>
                    <strong>Ano Final:</strong>
                    {{ item.EndYear }}
                  </p>
                  <p>
                    <strong>Parcelas:</strong>
                    {{ item.Installments }}
                  </p>
                  <p>
                    <strong>Tac:</strong>
                    {{ item.TAC }}
                  </p>
                  <p>
                    <strong>TacDev:</strong>
                    {{ item.TACdev }}
                  </p>
                  <p>
                    <strong>Retorno %:</strong>
                    {{ item.ReturnPercentage }}
                  </p>
                  <p>
                    <strong>Entrada:</strong>
                    {{ item.Input }}
                  </p>
                  <p>
                    <strong>Coeficiente:</strong>
                    {{ item.Coefficient }}
                  </p>
                  <p>
                    <strong>Coeficiente Rebate:</strong>
                    {{ item.RebateCoefficient }}
                  </p>
                  <p>
                    <strong>Validade:</strong>
                    {{ item.Validity }}
                  </p>
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_taxa(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <div v-for="item in itens" :key="item.id" class="accordion mb-2">
            <div class="accordion-item">
              <button
                class="accordion-button collapsed card-table-txt"
                data-bs-toggle="collapse"
                :data-bs-target="'#row-' + item.id"
              >
                {{ item.Name }}
              </button>
              <div :id="'row-' + item.id" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p>
                    <strong>Financeira:</strong>
                    {{ item.bancos_full ? item.bancos_full.nome : "N/A" }}
                  </p>
                  <p>
                    <strong>Retorno:</strong>
                    {{ item.ReturnType }}
                  </p>
                  <p>
                    <strong>Ano Inicial:</strong>
                    {{ item.StartYear }}
                  </p>
                  <p>
                    <strong>Ano Final:</strong>
                    {{ item.EndYear }}
                  </p>
                  <p>
                    <strong>Parcelas:</strong>
                    {{ item.Installments }}
                  </p>
                  <p>
                    <strong>Tac:</strong>
                    {{ item.TAC }}
                  </p>
                  <p>
                    <strong>TacDev:</strong>
                    {{ item.TACdev }}
                  </p>
                  <p>
                    <strong>Retorno %:</strong>
                    {{ item.ReturnPercentage }}
                  </p>
                  <p>
                    <strong>Entrada:</strong>
                    {{ item.Input }}
                  </p>
                  <p>
                    <strong>Coeficiente:</strong>
                    {{ item.Coefficient }}
                  </p>
                  <p>
                    <strong>Coeficiente Rebate:</strong>
                    {{ item.RebateCoefficient }}
                  </p>
                  <p>
                    <strong>Validade:</strong>
                    {{ item.Validity }}
                  </p>
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_taxa(item)"
                  >
                    <span>Editar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-lg-block">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Financeira</th>
                <th scope="col">Plano</th>
                <th scope="col">Retorno</th>
                <th scope="col">Ano Inicial</th>
                <th scope="col">Ano Final</th>
                <th scope="col">Parcelas</th>
                <th scope="col">TAC</th>
                <th scope="col">TACdev</th>
                <th scope="col">Retorno %</th>
                <th scope="col">Entrada</th>
                <th scope="col">Coeficiente</th>
                <th scope="col">Coef. Rebate</th>
                <th scope="col">Validade</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itens" :key="item.id" class="table-linha">
                <td>{{ item.bancos_full ? item.bancos_full.nome : "N/A" }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ item.ReturnType }}</td>
                <td>{{ item.StartYear }}</td>
                <td>{{ item.EndYear }}</td>
                <td>{{ item.Installments }}</td>
                <td>{{ item.TAC }}</td>
                <td>{{ item.TACdev }}</td>
                <td>{{ item.ReturnPercentage }}</td>
                <td>{{ item.Input }}</td>
                <td>{{ item.Coefficient }}</td>
                <td>{{ item.RebateCoefficient }}</td>
                <td>{{ item.Validity }}</td>
                <td>
                  <button
                    type="button"
                    class="dropdown-toggle-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_taxa(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal para edição -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal">Editar Taxa</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.id"
                    disabled
                  />
                  <label>ID</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="editForm.idSalesSector"
                    id="valid_status"
                    required
                  >
                    <option value="1">Novo</option>
                    <option value="2">Usado</option>
                  </select>
                  <label for="valid_status">Categoria</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Name"
                    required
                    autocomplete="off"
                  />
                  <label>Plano</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.ReturnType"
                  />
                  <label>Tipo Retorno</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.StartYear"
                  />
                  <label>Ano Inicial</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.EndYear"
                  />
                  <label>Ano Final</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    list="datalistBanco"
                    v-model="selectedOptionBanco.banco"
                    @change="updateSelectedOptionBanco"
                    class="form-control txt-form-input"
                  />
                  <label>Banco</label>

                  <datalist id="datalistBanco">
                    <option>{{ this.edit_idBank }}</option>
                    <option
                      v-for="banco in bancos"
                      :value="banco.nome"
                      :selected="selectedOptionBanco.id === banco.id"
                      :key="banco.id"
                    >
                      {{ banco.nome }}
                    </option>
                  </datalist>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Installments"
                  />
                  <label>Parcelas</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Validity"
                  />
                  <label>Validade</label>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.TAC"
                  />
                  <label>TAC</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.TACdev"
                  />
                  <label>TACdev</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.ReturnPercentage"
                  />
                  <label>Retorno %</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Plus"
                  />
                  <label>Plus</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Input"
                  />
                  <label>Entrada</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Coefficient"
                  />
                  <label>Coeficiente</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.Rebate"
                  />
                  <label>Rebate</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.RebateCoefficient"
                  />
                  <label>Coeficiente Rebate</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="editForm.SpfCoefficient"
                  />
                  <label>Spf Coeficiente</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="update()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <pagination
        v-if="itens.length"
        :total="totalItems"
        :limit="filtros.pageSize"
        :offset="currentPage"
        :totalPages="Math.ceil(totalItems / filtros.pageSize)"
        @change-page="handlePageChange"
      /> -->
      </div>
    </div>
    <!-- Modal para cadastro -->
    <div
      class="modal fade"
      id="ModalCadastrar"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal">Cadastrar Taxa</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="insertForm.idSalesSector"
                    id="valid_status"
                    required
                  >
                    <option value="1">Novo</option>
                    <option value="2">Usado</option>
                  </select>
                  <label for="valid_status">Categoria</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Name"
                    required
                    autocomplete="off"
                  />
                  <label>Plano</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.ReturnType"
                  />
                  <label>Tipo Retorno</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.StartYear"
                  />
                  <label>Ano Inicial</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.EndYear"
                  />
                  <label>Ano Final</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    list="datalistBanco"
                    v-model="selectedOptionBanco.banco"
                    @change="updateSelectedOptionBanco"
                    class="form-control txt-form-input"
                  />
                  <label>Banco</label>

                  <datalist id="datalistBanco">
                    <option>{{ this.edit_idBank }}</option>
                    <option
                      v-for="banco in bancos"
                      :value="banco.nome"
                      :selected="selectedOptionBanco.id === banco.id"
                      :key="banco.id"
                    >
                      {{ banco.nome }}
                    </option>
                  </datalist>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Installments"
                  />
                  <label>Parcelas</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Validity"
                  />
                  <label>Validade</label>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.TAC"
                  />
                  <label>TAC</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.TACdev"
                  />
                  <label>TACdev</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.ReturnPercentage"
                  />
                  <label>Retorno %</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Plus"
                  />
                  <label>Plus</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Input"
                  />
                  <label>Entrada</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Coefficient"
                  />
                  <label>Coeficiente</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.Rebate"
                  />
                  <label>Rebate</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.RebateCoefficient"
                  />
                  <label>Coeficiente Rebate</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="insertForm.SpfCoefficient"
                  />
                  <label>Spf Coeficiente</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="cadastar_taxa()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="cadastar_taxa()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="abrir_modal">
      <Message :msg="msg" v-show="msg" />
    </div>
    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import userService from "../../services/user.service";
//import Pagination from "../../components/Pagination.vue";
import axios from "axios";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";

export default {
  components: {
    SidebarVue,
    Navgator,
    Message,
    RodapeVue
    // Pagination
  },
  data: () => ({
    form: { file: null },
    itens: [],
    bancos: [],
    validade: "",
    msg: null,
    abrir_modal: null,

    // ESTADOS AGRUPADOS - MELHORIA 1
    filtros: {
      desc_taxa: "",
      pageSize: 100
    },

    selectedOptionBanco: { id: null, banco: "" },

    // FORMULÁRIO DE EDIÇÃO AGRUPADO - MELHORIA 1
    editForm: {
      id: "",
      Name: "",
      idSalesSector: "",
      ReturnType: "",
      StartYear: "",
      EndYear: "",
      Installments: "",
      Validity: "",
      idBank: "",
      TAC: "",
      TACdev: "",
      ReturnPercentage: "",
      Plus: "",
      Input: "",
      Coefficient: "",
      Rebate: "",
      RebateCoefficient: "",
      SpfCoefficient: ""
    },
    insertForm: {
      Name: "",
      idSalesSector: "",
      ReturnType: "",
      StartYear: "",
      EndYear: "",
      Installments: "",
      Validity: "",
      idBank: "",
      TAC: "",
      TACdev: "",
      ReturnPercentage: "",
      Plus: "",
      Input: "",
      Coefficient: "",
      Rebate: "",
      RebateCoefficient: "",
      SpfCoefficient: ""
    },

    // PAGINAÇÃO (já estava organizado)
    page: 1,
    totalPages: 0,
    totalItems: 0,
    pageSizes: [100, 200, 300, 400, 500]
  }),
  created() {
    this.retrieveTaxas();
    this.retrieveBancos();
  },
  methods: {
    getRequestParams(desc_taxa, banco_taxa, page, pageSize) {
      let params = {};
      if (desc_taxa) {
        params["nome"] = this.filtros.desc_taxa;
      }
      if (banco_taxa) {
        params["banco"] = banco_taxa;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    handlePageChange(value) {
      this.page = value;
      this.retrieveTaxas();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveTaxas();
    },
    async retrieveTaxas() {
      try {
        const params = this.getRequestParams(
          this.filtros.desc_taxa,
          this.banco_taxa,
          this.page,
          this.filtros.pageSize
        );
        userService.getTaxasAll(params).then((response) => {
          const { parcelas, totalPages, totalItems } = response.data;
          this.itens = parcelas;
          this.totalPages = totalPages;
          this.totalItems = totalItems;
          this.validade = parcelas[0].Validity;
          console.log("Taxas otimizadas", this.itens);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async retrieveBancos() {
      try {
        const bancos = await axios.get(
          `${process.env.VUE_APP_API_URL}get_bancos`
        );
        this.bancos = bancos.data.rows;
        console.log(this.bancos);
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    updateSelectedOptionBanco() {
      const selectedOption = this.bancos.find(
        (option) => option.nome === this.selectedOptionBanco.banco
      );
      if (selectedOption) {
        this.selectedOptionBanco = {
          id: selectedOption.id,
          banco: selectedOption.nome
        };
      } else {
        this.selectedOptionBanco = { id: this.edit_idBank, nome: "" };
      }
      console.log(this.selectedOptionBanco);
    },
    async editar_taxa(item) {
      console.log("Dados para edição");
      console.log(item.bancos_full ? item.bancos_full.nome : "N/A");
      (this.edit_id = item.id),
        (this.edit_Name = item.Name),
        (this.edit_idSalesSector = item.IdSalesSector),
        (this.edit_ReturnType = item.ReturnType),
        (this.edit_StartYear = item.StartYear),
        (this.edit_EndYear = item.EndYear),
        (this.edit_Installments = item.Installments),
        (this.edit_Validity = item.Validity),
        (this.edit_idBank = item.IdBank),
        (this.selectedOptionBanco.banco = item.bancos_full
          ? item.bancos_full.nome
          : "N/A"),
        (this.edit_TAC = item.TAC),
        (this.edit_TACdev = item.TACdev),
        (this.edit_ReturnPercentage = item.ReturnPercentage),
        (this.edit_Plus = item.Plus),
        (this.edit_Input = item.Input),
        (this.edit_Coefficient = item.Coefficient),
        (this.edit_Rebate = item.Rebate),
        (this.edit_RebateCoefficient = item.RebateCoefficient),
        (this.edit_SpfCoefficient = item.SpfCoefficient);
      this.updateSelectedOptionBanco();
    },
    async update() {
      const token = this.$store.state.auth.user.accessToken;
      const headers = {
        "x-access-token": token
      };
      const dados = {
        id: this.edit_id,
        Name: this.edit_Name,
        IdSalesSector: this.edit_idSalesSector,
        ReturnType: this.edit_ReturnType,
        StartYear: this.edit_StartYear,
        EndYear: this.edit_EndYear,
        FinancingPlanType: 1,
        Spf: 1,
        Installments: this.edit_Installments,
        Validity: this.edit_Validity,
        IdBank: this.edit_idBank,
        TAC: this.edit_TAC,
        TACdev: this.edit_TACdev,
        ReturnPercentage: this.edit_ReturnPercentage,
        Plus: this.edit_Plus,
        Input: this.edit_Input,
        Coefficient: this.edit_Coefficient,
        Rebate: this.edit_Rebate,
        RebateCoefficient: this.edit_RebateCoefficient,
        SpfCoefficient: this.edit_SpfCoefficient
      };
      console.log(dados);

      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}taxas/${this.edit_id}`,
        dados,
        { headers }
      );
      console.log(response.data.StatusOk);
      if (response.data.StatusOk == 200) {
        this.abrir_modal = true;
        this.msg = response.data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
        // this.resetForm();
        // this.retrieveFamilias();
        //window.location.reload();
      }
      return console.log(response.data);
    },

    async importar() {
      console.log("Importar taxas");
      let dataForm = new FormData();

      for (let file of this.$refs.files.files) {
        dataForm.append(`file`, file);
      }
      let res = await fetch(
        `${process.env.VUE_APP_API_URL}taxas/upload_apresentacaofull`,
        {
          method: "POST",

          body: dataForm
        }
      );
      let data = await res.json();
      if (data.StatusOk == 200) {
        this.abrir_modal = true;
        this.msg = data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
      } else {
        this.abrir_modal = true;
        this.msg = data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    }
  }
};
</script>
